module.exports = __webpack_public_path__ + "media/img/uploads/solutions-tall-thumb-05-773888a1c46a17e7ca600e0532a1ace6.jpg";